"use client";
import { useState } from "react";
import {useTranslations} from 'next-intl';
import {useBaseMutation} from '@/libs/api/baseRequests';
import {SEND_REQUEST_MUTATION} from '@/graphql/mutations';
import {checkValidPhoneNumber} from '@/libs/string.util';

export default function ContactPrimary() {
  const t = useTranslations('contact');
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    message: '',
    agree: false,
  });
  const [phoneStatus, setPhoneStatus] = useState('correct');
  const [loading, setLoading] = useState(false);
  const {mutate} = useBaseMutation(SEND_REQUEST_MUTATION, {
    toastOnComplete: { toast: true }
  });
  
  const handleChange = (e) => {
    const { name, value, checked } = e.target;
    setFormData({
      ...formData,
      [name]: name === "agree" ? checked : value,
    });
    if (name === 'phone') {
      setPhoneStatus(value.length && !checkValidPhoneNumber(value) ? 'error' : 'correct');
    }
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await mutate({
      variables: {
        name: formData.name.trim(),
        telNumber: formData.phone.trim(),
        message: formData.message.trim()
      }
    });
    setLoading(false);
    setFormData({
      name: '',
      phone: '',
      message: '',
      agree: false,
    });
  };
  return (
      <div className="ltn__contact-message-area mb-120">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="ltn__form-box contact-form-box box-shadow white-bg">
                <h4 className="title-2">{t('orderCall')}</h4>
                <form id="contact-form" onSubmit={(e) => handleSubmit(e)}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="input-item input-item-name ltn__custom-icon">
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={(e) => handleChange(e)}
                            placeholder={t('enterName')}
                            required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className={`input-item input-item-phone ltn__custom-icon input-error-wrapper on-${phoneStatus}`}>
                        <input
                            type="text"
                            name="phone"
                            value={formData.phone}
                            onChange={(e) => handleChange(e)}
                            placeholder={t('enterPhone')}
                            required
                        />
                        <span className="error-text">{t('errorPhone')}</span>
                      </div>
                    </div>
                  </div>
                  <div className="input-item input-item-textarea input-item-phone ltn__custom-icon">
                  <textarea
                      name="message"
                      placeholder={t('enterMessage')}
                      value={formData.message}
                      onChange={(e) => handleChange(e)}
                      required
                  />
                  </div>
                  <div>
                    <label className="input-info-save mb-0">
                      <input
                          type="checkbox"
                          name="agree"
                          onChange={(e) => handleChange(e)}
                          checked={formData.agree}
                      />{' '}{t('agreementCheck')}
                    </label>
                  </div>
                  <div className="btn-wrapper mt-2">
                    <button
                        className="btn theme-btn-1 btn-effect-1 text-uppercase"
                        type="submit"
                        disabled={!formData.name || !formData.message || !checkValidPhoneNumber(formData.phone) || !formData.agree || loading}
                    >
                      {loading ? t('sending') : t('submit')}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};
